"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../../utils/constants");
var muiMobilePhone16 = {
    paths: [
        {
            path: 'M2,12 L8,12 L8,2 L2,2 L2,12 Z M9.00460243,0 C9.55434533,0 10,0.444630861 10,1.00087166 L10,14.9991283 C10,15.5518945 9.5443356,16 9.00460243,16 L0.995397568,16 C0.445654671,16 0,15.5553691 0,14.9991283 L0,1.00087166 C0,0.448105505 0.455664396,0 0.995397568,0 L9.00460243,0 Z M5,13 L4.88266744,13.0067277 C4.38272018,13.0644928 4,13.4871642 4,14 C4,14.5561352 4.44771525,15 5,15 L5,15 L5.11733256,14.9932723 C5.61727982,14.9355072 6,14.5128358 6,14 L6,14 L5.99327227,13.8826674 C5.93550716,13.3827202 5.51283584,13 5,13 L5,13 Z',
            fill: constants_1.defaultFill,
        },
    ],
    title: 'Mobile Phone',
    width: 10,
    height: 16,
};
var muiMobilePhone24 = {
    paths: [
        {
            path: 'M2,19 L13,19 L13,2 L2,2 L2,19 Z M13.5069036,0 C14.331518,0 15,0.666946292 15,1.50130749 L15,22.4986925 C15,23.3278417 14.3165034,24 13.5069036,24 L1.49309635,24 C0.668482007,24 0,23.3330537 0,22.4986925 L0,1.50130749 C0,0.672158257 0.683496594,0 1.49309635,0 L13.5069036,0 Z M7.5,20 L7.35463714,20.0068666 C6.58977194,20.0795513 6,20.7203039 6,21.5 C6,22.3342028 6.67157288,23 7.5,23 L7.5,23 L7.64536286,22.9931334 C8.41022806,22.9204487 9,22.2796961 9,21.5 L9,21.5 L8.99313342,21.3546371 C8.92044868,20.5897719 8.27969612,20 7.5,20 L7.5,20 Z',
            fill: constants_1.defaultFill,
        },
    ],
    title: 'Mobile Phone',
    width: 15,
    height: 24,
};
var muiMobilePhone = {
    base: muiMobilePhone16,
    smIcon: muiMobilePhone16,
    lgIcon: muiMobilePhone24,
};
exports.muiMobilePhone = muiMobilePhone;
//# sourceMappingURL=mobilePhone.js.map